module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (28).88c0faaf.jpg";